import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-lg modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "modal-title",
  id: "add-room-item-modal-label"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-title",
  id: "add-room-item-modal-label"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "modal-body" }
const _hoisted_10 = { class: "form-group row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Flag", -1)
const _hoisted_12 = { class: "col-sm-4" }
const _hoisted_13 = { class: "form-group row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Symbol", -1)
const _hoisted_15 = { class: "col-sm-3" }
const _hoisted_16 = { class: "form-group row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Description", -1)
const _hoisted_18 = { class: "col-sm-9" }
const _hoisted_19 = { class: "form-group row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "PDF Guide", -1)
const _hoisted_21 = { class: "col-sm-9" }
const _hoisted_22 = { class: "form-group row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Colour", -1)
const _hoisted_24 = { class: "col-sm-9 d-flex align-items-center" }
const _hoisted_25 = { class: "form-group row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Background colour", -1)
const _hoisted_27 = { class: "col-sm-9 d-flex align-items-center" }
const _hoisted_28 = { class: "form-group row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "PDF Display type", -1)
const _hoisted_30 = { class: "col-sm-9" }
const _hoisted_31 = { class: "modal-footer" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["disabled"]

import $ from 'jquery';
import { computed, inject, ref } from 'vue';
import { useStore } from 'vuex';
import { snakeCase } from 'lodash';
import { useToast } from 'vue-toastification';
import { Maintenanceflag, SelectOption } from '@/models';
import TiptapEditor from '@/components/editor/TiptapEditor.vue';
// Define props

export default /*#__PURE__*/_defineComponent({
  __name: 'MaintenanceflagModal',
  props: {
    id: {},
    operation: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const store = useStore();
const toasted = useToast();
const actProperty: any = inject('actProperty');
const validColorCode = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;

const selectedmaintenanceflag = computed(() => store.getters['customerdictionary/selectedmaintenanceflag']);
const maintenanceflags = computed((): Maintenanceflag[] => store.getters['customerdictionary/maintenanceflags']);


const addToMaintenanceflags = (flag: {}): Promise<any> => {
  return store.dispatch('customerdictionary/addToMaintenanceflags', flag);
};

const setSelectedMaintenanceflag = (flag: Maintenanceflag): void => {
  store.commit('customerdictionary/setSelectedMaintenanceflag', flag);
};

const setCustomerdictionaryDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('customerdictionary/setCustomerdictionaryDeep', payload);
};

const typeOptions: SelectOption[] = [
  { name: 'Extract', slug: 'extract' },
  { name: 'Embed', slug: 'embed' },
];

const symbolOptions: SelectOption[] = [
  {
    name: "fa-bell-exclamation-red",
    slug: "fa-bell-exclamation-red",
    icon: "fa-bell-exclamation-red",
  },
  {
    name: "fa-bell-on",
    slug: "fa-bell-on",
    icon: "fa-bell-on",
  },
  {
    name: "fa-brake-warning",
    slug: "fa-brake-warning",
    icon: "fa-brake-warning",
  },
  {
    name: "fa-brush",
    slug: "fa-brush",
    icon: "fa-brush",
  },
  {
    name: "fa-hammer",
    slug: "fa-hammer",
    icon: "fa-hammer",
  },
  {
    name: "fa-lightbulb-exclamation",
    slug: "fa-lightbulb-exclamation",
    icon: "fa-lightbulb-exclamation",
  },
  {
    name: "fa-screwdriver-wrench",
    slug: "fa-screwdriver-wrench",
    icon: "fa-screwdriver-wrench",
  },
  {
    name: "fa-triangle-exclamation",
    slug: "fa-triangle-exclamation",
    icon: "fa-triangle-exclamation",
  },
  {
    name: "fa-wrench",
    slug: "fa-wrench",
    icon: "fa-wrench",
  },
];

const pdfDisplay = computed({
  get: () => typeOptions.find(option => option.slug === selectedmaintenanceflag.value.pdfDisplay),
  set: (value: SelectOption | undefined) => {
    if (value) selectedmaintenanceflag.value.pdfDisplay = value.slug;
  }
});

const displayguide = computed({
  get: () => selectedmaintenanceflag.value.displayguide,
  set: (value: string) => {
    selectedmaintenanceflag.value.displayguide = value;
  }
});

const selectedmaintenanceflagcolour = computed({
  get: () => selectedmaintenanceflag.value.colour,
  set: value => {
    if(validColorCode.test(value)){
      selectedmaintenanceflag.value.colour = value;
    }
  }
});

const selectedmaintenanceflagbackgroundcolour = computed({
  get: () => selectedmaintenanceflag.value.backgroundcolour,
  set: value => {
    if(validColorCode.test(value)){
      selectedmaintenanceflag.value.backgroundcolour = value;
    }
  }
});

function onSelectPdfDisplay(value: SelectOption) {
  selectedmaintenanceflag.value.pdfDisplay = value.slug;
}

function onSelectSymbol(value: SelectOption) {
  selectedmaintenanceflag.value.symbol = value.icon ? value.icon : '';
}

function updateDisplayguide(value: string) {
  selectedmaintenanceflag.value.displayguide = value;
}

function canAdd(): boolean {
  let result = true;
  return result;
}

async function add() {
  selectedmaintenanceflag.value.slug = snakeCase(selectedmaintenanceflag.value.flag);
  addToMaintenanceflags(selectedmaintenanceflag.value)
    .then(() =>
      toasted.success(
        `Added "${selectedmaintenanceflag.value.description}"`
      )
    )
    .then(() => reset())
    .catch((err: any) => {
      actProperty.displayError(err);
    });
  hide();

}

async function save() {
  let index = maintenanceflags.value.findIndex(f => f.slug === selectedmaintenanceflag.value.slug);
  if (index >= 0) {
    selectedmaintenanceflag.value.slug = snakeCase(selectedmaintenanceflag.value.flag);
    setCustomerdictionaryDeep({
      path: `maintenance_list[${index}]`,
      data: selectedmaintenanceflag.value,
    })
      .then(() =>
        toasted.warning(`Locally saved "${selectedmaintenanceflag.value.description}. Please remember to press final Save"`)

      )
      .then(() => reset())
      .catch((err: any) => {
        actProperty.displayError(err);
      });
  }

  hide();
}

function reset() {
  setSelectedMaintenanceflag(new Maintenanceflag());
}
const show = () => {
  if ($(`#${props.id}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.id + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.id}`).show();
  }
}
const hide = () => {
  if ($(`#${props.id}`).length > 0) {
    $(`#${props.id}` + 'Backdrop').remove();
    $(`#${props.id}`).hide();
  }
};
__expose({ add, show, hide });

return (_ctx: any,_cache: any) => {
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`midterm-question-modal-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.operation == 'add')
            ? (_openBlock(), _createElementBlock("h5", _hoisted_5, " New Flag "))
            : (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(selectedmaintenanceflag.value.flag), 1)),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedmaintenanceflag.value.flag) = $event))
                }, null, 512), [
                  [_vModelText, selectedmaintenanceflag.value.flag]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_multiselect, {
                  modelValue: selectedmaintenanceflag.value.symbol,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedmaintenanceflag.value.symbol) = $event)),
                  "track-by": "slug",
                  options: symbolOptions,
                  onSelect: onSelectSymbol,
                  "show-labels": false
                }, {
                  singleLabel: _withCtx(({ option }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass([option, "flag-icon"])
                    }, null, 2)
                  ]),
                  option: _withCtx(({ option }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass([option.icon, "flag-icon"])
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedmaintenanceflag.value.description) = $event))
                }, null, 512), [
                  [_vModelText, selectedmaintenanceflag.value.description]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(), _createBlock(TiptapEditor, {
                  content: displayguide.value,
                  onBlur: _cache[4] || (_cache[4] = ($event: any) => (updateDisplayguide($event))),
                  key: selectedmaintenanceflag.value.flag
                }, null, 8, ["content"]))
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _withDirectives(_createElementVNode("input", {
                  type: "color",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedmaintenanceflagcolour).value = $event)),
                  class: "form-control",
                  style: {"width":"75px","margin-right":"2px"}
                }, null, 512), [
                  [_vModelText, selectedmaintenanceflagcolour.value]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedmaintenanceflagcolour).value = $event)),
                  class: "form-control",
                  style: {"width":"100px"}
                }, null, 512), [
                  [
                    _vModelText,
                    selectedmaintenanceflagcolour.value,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _withDirectives(_createElementVNode("input", {
                  type: "color",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedmaintenanceflagbackgroundcolour).value = $event)),
                  class: "form-control",
                  style: {"width":"75px","margin-right":"2px"}
                }, null, 512), [
                  [_vModelText, selectedmaintenanceflagbackgroundcolour.value]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedmaintenanceflagbackgroundcolour).value = $event)),
                  class: "form-control",
                  style: {"width":"100px"}
                }, null, 512), [
                  [
                    _vModelText,
                    selectedmaintenanceflagbackgroundcolour.value,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_multiselect, {
                  modelValue: pdfDisplay.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((pdfDisplay).value = $event)),
                  "track-by": "slug",
                  label: "name",
                  options: typeOptions,
                  onSelect: onSelectPdfDisplay
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary mr-auto",
            "data-dismiss": "modal",
            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, " Back "),
          (_ctx.operation == 'add')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "submit",
                class: "btn btn-primary",
                onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (add()), ["prevent"])),
                disabled: !canAdd()
              }, " Add question ", 8, _hoisted_32))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "submit",
                class: "btn btn-primary",
                onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (save()), ["prevent"])),
                disabled: !canAdd()
              }, " Ok ", 8, _hoisted_33))
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})